import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { Link as RouterLink } from 'react-router-dom';
import { useI18n } from '@/i18n/I18nContext';

const Footer: React.FC = () => {
	const { t } = useI18n();
	return (
		<Box component="footer" sx={{ py: 6, mt: 8, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
			<Container maxWidth="lg">
				<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
					<Typography variant="body2" color="text.secondary">
						{t.footer.copyright}
					</Typography>
					<Stack direction="row" spacing={3}>
						<Link component={RouterLink} to="/privacy" underline="hover" color="text.secondary">
							{t.footer.privacy}
						</Link>
						<Link component={RouterLink} to="/terms" underline="hover" color="text.secondary">
							{t.footer.terms}
						</Link>
						<Link component={RouterLink} to="/contact" underline="hover" color="text.secondary">
							{t.footer.contact}
						</Link>
					</Stack>
				</Stack>
			</Container>
		</Box>
	);
};

export default Footer;
